import React, { createContext, useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { toTallyEmbed } from "../lib/api";
import { useSettings } from "./SettingsContext";

const ContactContext = createContext(null);
export const useContact = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);
  const embed = toTallyEmbed(settings?.tally_url);

  return (
    <ContactContext.Provider value={{ openTally: () => setOpen(true) }}>
      {children}
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[110] flex items-center justify-center p-4 md:p-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            style={{ background: "rgba(3,3,3,0.9)", backdropFilter: "blur(6px)" }}
            data-testid="tally-modal"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-6 right-6 p-2 text-white/70 hover:text-white transition-colors"
              data-testid="tally-modal-close"
              aria-label="close"
            >
              <X size={28} />
            </button>
            <motion.div
              initial={{ scale: 0.95, y: 20, opacity: 0 }}
              animate={{ scale: 1, y: 0, opacity: 1 }}
              exit={{ scale: 0.96, opacity: 0 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="w-full max-w-2xl overflow-hidden rounded-2xl border"
              style={{ borderColor: "var(--border-color)", background: "var(--surface-color)", maxHeight: "88vh" }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="px-6 md:px-8 pt-7 pb-4 border-b" style={{ borderColor: "var(--border-color)" }}>
                <span className="text-xs uppercase tracking-[0.35em]" style={{ color: "var(--accent-color)" }}>
                  Start a project
                </span>
                <h3 className="mt-2 font-heading text-2xl font-semibold tracking-tight">Tell me about it.</h3>
              </div>
              {embed && (
                <iframe
                  src={embed}
                  title="Start a project"
                  className="w-full"
                  style={{ height: "60vh", border: "0", background: "transparent" }}
                  data-testid="tally-iframe"
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </ContactContext.Provider>
  );
};
